export const validation = {
  selectProviderName: 'Please select provider name',
  selectPartTitle: 'Please select part title',
  selectSupplyHouse: 'Please select supply house ',
};
